import { z } from 'zod'

import { PLACEHOLDER_MINIMUM_USDC_PRICE } from 'components/Web3/CreateTownWithDuration/createTownWithDuration.schema'

const minPrice = parseFloat(PLACEHOLDER_MINIMUM_USDC_PRICE)

export const upgradeToUsdcSchema = z.object({
    amount: z
        .string()
        .min(1, 'Amount is required')
        .refine((val) => {
            const num = parseFloat(val)
            return !isNaN(num) && (num === 0 || num >= minPrice)
        }, `Amount must be 0 or at least $${PLACEHOLDER_MINIMUM_USDC_PRICE}`),
})

export type UpgradeToUsdcSchema = z.infer<typeof upgradeToUsdcSchema>
